export const LOAD_CATEGORY_SECTION_REQUEST = 'LOAD_CATEGORY_SECTION_REQUEST';
export const LOAD_CATEGORY_SECTION_SUCCESS = 'LOAD_CATEGORY_SECTION_SUCCESS';
export const LOAD_CATEGORY_SECTION_FAIL = 'LOAD_CATEGORY_SECTION_FAIL';
